import * as React from "react";
const SvgFiRrAnalyse = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-analyse_svg__a)">
      <path
        fill="#062147"
        d="M23.707 23.707a.997.997 0 0 1-1.414 0l-5.969-5.969A9.95 9.95 0 0 1 10 20C4.486 20 0 15.514 0 10S4.486 0 10 0c1.758 0 3.487.463 5.001 1.338a1 1 0 1 1-1.002 1.732A8 8 0 0 0 10 2c-4.411 0-8 3.589-8 8 0 1.167.257 2.274.709 3.274l3.799-4.559a2.025 2.025 0 0 1 2.986-.135l1.928 1.928L20.237.34a1 1 0 0 1 1.514 1.308l-8.78 10.166a2.03 2.03 0 0 1-1.458.7 2.06 2.06 0 0 1-1.505-.592L8.08 9.994l-4.263 5.075A7.99 7.99 0 0 0 10 17.999c4.411 0 8-3.589 8-8q0-.225-.013-.447a1 1 0 0 1 .946-1.052c.547-.04 1.022.394 1.052.945q.015.275.015.553c0 2.398-.85 4.6-2.262 6.324l5.969 5.969a1 1 0 0 1 0 1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-analyse_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAnalyse;
